<template>
  <div class="user_security">
    <HeaderComponents></HeaderComponents>
    <div class="content">
      <div class="card">
        <div class="title">设置密码</div>
        <Form class="form" :label-width="80" label-position="left" autocomplete="off">
          <FormItem label="当前账号:">
            <Input class="input" v-model="loginForm.phone" placeholder="" disabled></Input>
          </FormItem>
          <FormItem label="验证码:">
            <Input class="input" placeholder="请输入验证码" style="width: 188px"  :maxlength="4" v-model="loginForm.code"
              name="set-password-code" autocomplete="one-time-code"></Input>
            <Button type="primary" style="width:150px;height: 40px;margin-left: 18px" @click="getCode()" :disabled="!show">
              <span v-if="show">获取验证码</span>
              <span v-if="!show">{{count}} s</span>
            </Button>
          </FormItem>
          <FormItem label="输入密码:">
            <Input class="input" type="password"  :maxlength="16" placeholder="请输入密码" v-model="loginForm.newPassword"
              name="set-password-new" autocomplete="new-password"></Input>
          </FormItem>
          <FormItem label="确认密码:">
            <Input class="input" type="password"  :maxlength="16" placeholder="请再次输入密码" v-model="loginForm.second_password"
              name="set-password-confirm" autocomplete="new-password"></Input>
          </FormItem>
          <div class="footer">
            <Button type="primary" @click="submit">确认修改</Button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponents from '../../components/header'

export default {
  name: 'user_security',
  components: {
    HeaderComponents
  },
  data () {
    return {
      loginForm: {
        phone: '',
        newPassword: '',
        second_password: '',
        code: '',
      },
      show: true,
      count: 60,
      timer: null,
    }
  },
  created(){
    let vm = this
    this.$request('6173cb9f48207', {
    }).then(res => {
      vm.loginForm.phone = res.data.data.user.phone
      vm.clearSensitiveFields()

    })
  },
  mounted() {
    this.clearSensitiveFields()
    setTimeout(() => {
      this.clearSensitiveFields()
    }, 300)
  },
  methods:{
    clearSensitiveFields() {
      this.loginForm.second_password = ''
      this.loginForm.newPassword = ''
      this.loginForm.code = ''
    },
    submit(){
      let vm = this
      if (!this.loginForm.newPassword) {
        return this.$message.error('请输入密码')
      }
      if (!this.loginForm.second_password) {
        return this.$message.error('请再次输入密码')
      }
      if (this.loginForm.newPassword != this.loginForm.second_password) {
        return this.$message.error('两次密码不一致')
      }
      if (!this.loginForm.code) {
        return this.$message.error('请输入验证码')
      }
      this.$request('6174ce42ebd82', this.loginForm).then(res => {
        vm.loginForm.code = ""
        vm.loginForm.second_password = ""
        vm.loginForm.newPassword = ""
        return this.$message.success('修改成功')
      })
    },
    getCode(){
      if (this.loginForm.phone == ""){
        return this.$message.error('请输入手机号')
      }

      if (!this.timer){
        this.$request('610796cfa73ad', {
          phone: this.loginForm.phone,
          type: "edit_password"
        }).then(res => {
          this.show = false
          this.count = 60
          this.timer = setInterval(()=>{
            if (this.count > 0 && this.count <= 60){
              this.count--;
            }else{
              this.show = true
              clearInterval(this.timer)
              this.timer = null
            }
          },1000)
        })
      }else {
        return this.$message.error('请求验证码频繁')
      }
    }
  }
}
</script>

<style scoped lang="less">
.user_security {
  .content {
    min-width: 1200px;
    padding: 0 100px;
    background-color: #f7f8fa;
    margin-top: 84px;

  }

  .card {
    background-color: #FFFFFF;
    padding: 20px;
    border-radius: 3px;

    .title {
      font-size: 18px;
      color: #333;
      font-weight: 450;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 70px;
        height: 3px;
        background-color: #FB9E2F;
      }
    }
    .form {
      margin-top: 60px;

      .input {
        width: 300px;
      }

      .footer{
        margin-top: 30px;
        margin-bottom: 20px;
      }
    }
  }
}

</style>
